import { Solution } from '@energiebespaarders/constants';
import { Icon, Tooltip } from '@energiebespaarders/symbols';
import { Blue, Medium } from '@energiebespaarders/symbols/helpers';
import { Information } from '@energiebespaarders/symbols/icons/solid';
import React from 'react';

export const debWarranty = (
  <React.Fragment key="deb-warranty">
    <h5>Energiebespaarders Garantie</h5>
    <p>
      Bovenop de installatiegarantie geeft Energiebespaarders nog een extra garantie: de{' '}
      <Medium>Energiebespaarders Garantie</Medium>. Mocht er onverhoopt tijdens de installatie iets
      misgaan en komt u er met de installateur onderling niet uit, dan maakt u aanspraak op de
      Energiebespaarders Garantie. Met deze garantie bent u verzekerd tot een maximaal bedrag van
      €100.000 en zorgen wij dat een onafhankelijke partij herstelwerkzaamheden uitvoert zodat het
      project alsnog netjes wordt afgerond.
    </p>
  </React.Fragment>
);

export const purInfo = (
  <React.Fragment key="pur-info">
    <h5>Isolatieschuim</h5>
    <p>
      Na het aanbrengen van de isolatie met een schuim, verzoeken wij u uw woning goed te ventileren
      i.v.m. de geur van het schuim. Dit is niet schadelijk en zal na enige tijd verdwijnen. ISOPA
      (de Europese branchevereniging voor fabrikanten van PUR) adviseert om uw woning tijdens en tot
      2 uur na het aanbrengen van PUR te verlaten. Door de woning tijdelijk te verlaten, wordt ieder
      mogelijk contact met stoffen die incidenteel in de leefruimtes zouden kunnen vrijkomen tijdens
      het aanbrengen van de isolatie uitgesloten. Het risico wordt hierdoor van verwaarloosbaar naar
      nul teruggebracht.
    </p>
  </React.Fragment>
);

export const insulationCertificationWarranty = (
  solution: Solution,
  certification: 'insula' | 'skg',
) => [
  <p key="insulationCertificationWarranty-1">
    De installatiegarantie geldt 10 jaar, behoudens nadere schriftelijke omschrijving betrekking op
    het uitvoeren van de werkzaamheden volgens de richtlijnen van{' '}
    {certification === 'skg' ? (
      <a href="https://www.skgikob.nl/" title="SKG-IKOB" rel="noopener noreferrer" target="_blank">
        SKG-IKOB
      </a>
    ) : (
      <a
        href="https://insula-certificatie.nl/"
        title="Insula Certificatie"
        rel="noopener noreferrer"
        target="_blank"
      >
        Insula
      </a>
    )}{' '}
    en{' '}
    <a href="http://www.komo.nl/" title="Stichting KOMO" rel="noopener noreferrer" target="_blank">
      KOMO
    </a>
    . De garantie geldt niet indien de oorzaak van de fouten niet duidelijk kan worden aangetoond.
  </p>,
  <Tooltip
    key="insulationCertificationWarranty-2"
    bgColor="grayDarker"
    content={
      <ul>
        {solution === Solution.WallInsulation && (
          <>
            <li>
              In het geval de gevel uit een poreuze steen bestaat, wordt er geadviseerd de gevel te
              impregneren vóór er geïsoleerd wordt. Energiebespaarders biedt geen garantie op
              problemen ontstaan door het isoleren van de spouwmuur indien opdrachtgever ervoor
              kiest om de gevel niet te impregneren.
            </li>
            <li>
              Energiebespaarders biedt geen garantie op de afwerklaag en/of geglazuurde stenen van
              de gevel. Opdrachtgever erkent de risico’s van deze gevel in combinatie met
              isolatiewerkzaamheden en vrijwaart Energiebespaarders van de gevolgen van haar
              werkzaamheden.
            </li>
          </>
        )}
        <li>Indien de oorzaak van de fouten niet duidelijk kan worden gemaakt;</li>
        <li>
          Indien de fouten geheel of gedeeltelijk het gevolg zijn van overheidsvoorschriften met
          betrekking tot de kwaliteit of de aard van de gebruikte materialen of met betrekking tot
          de fabricage;
        </li>
        <li>
          Indien wijzigingen of reparaties die op eigen initiatief gedurende de garantietermijn
          worden verricht;
        </li>
        <li>
          Indien de wederpartij niet, niet behoorlijk, of niet tijdig voldoet aan enige
          verplichting, welke uit deze of enige andere daarmede samenhangende transactie
          voortvloeit.
        </li>
      </ul>
    }
    placement="top"
    maxWidth="600px"
    padding={1}
  >
    <p>
      <Blue>
        <Icon icon={Information} solid fill="blue" /> Wanneer komt de garantie te vervallen?
      </Blue>
    </p>
  </Tooltip>,
];

export const panelLayoutAnnotation = (
  <p key="panel-layout-annotation">
    Aan het legplan kunnen geen rechten worden ontleend en dient slechts ter indicatie. De
    uiteindelijke locatie van de panelen kan afwijken.
  </p>
);

export const windowGlazingAnnotation = (
  <React.Fragment key="window-glazing-annotation">
    <p>
      Omdat glas op maat wordt gemaakt in de fabriek en de glaszetter de maatvoering zelf wil
      nameten zodat het glas goed zal passen, worden ditmaal de productiematen opgemeten en volstaan
      hiervoor niet de dagmaten die vaak in eerste instantie door de adviseur van De
      Energiebespaarders zijn opgemeten.
    </p>
    <p>
      Houd er bij het bepalen van de afwijking tussen de oorspronkelijke offerte en een aangepaste
      (of nieuwe) offerte rekening mee dat u uitsluitend de som vergelijkt van identieke
      werkzaamheden. In andere woorden, als u bijvoorbeeld in overleg met de glaszetter besluit om
      extra werkzaamheden, grotere glasoppervlakken, of andere werkzaamheden te laten uitvoeren, dan
      tellen deze extra kosten of nieuwe kosten niet mee bij het bepalen van de afwijking.
    </p>
  </React.Fragment>
);
